import React from "react";
import s from "./ProductPackages.module.scss";

const ProductSelectorButton = ({ additionalClasses = "", ...props }) => {
  const baseClasses = `${s.productPackages__button}`;
  const combinedClasses = `${baseClasses} ${additionalClasses}`.trim();

  return <button data-testid="product-selector" className={combinedClasses} type="button" {...props} />;
};

export default ProductSelectorButton;
